"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = Property;
exports.Range = Range;
exports.TextArea = TextArea;
exports.ReadOnly = ReadOnly;
exports.Header = Header;
exports.Tooltip = Tooltip;
exports.Space = Space;
exports.Button = Button;
exports.getPropertyMetadata = getPropertyMetadata;
exports.getButtonMetadata = getButtonMetadata;
exports.Menu = Menu;
exports.getMenuMetadata = getMenuMetadata;
const Types_1 = require("../Types");
const NEXUS_BUTTON_METADATA = 'nexus:buttons';
const NEXUS_MENU_METADATA = 'nexus:menus';
/**
 * 属性装饰器 - 自动生成UI控件
 * @param options 属性配置选项
 * @returns 属性装饰器函数
 */
function Property(options) {
    return function (target, propertyKey) {
        const existingProperties = Reflect.getMetadata(Types_1.NEXUS_PROPERTY_METADATA, target.constructor) || {};
        existingProperties[propertyKey] = options || {};
        Reflect.defineMetadata(Types_1.NEXUS_PROPERTY_METADATA, existingProperties, target.constructor);
    };
}
/**
 * 范围装饰器 - 限制数值输入范围
 * @param min 最小值
 * @param max 最大值
 * @returns 属性装饰器函数
 */
function Range(min, max) {
    return Property({ min, max });
}
/**
 * 多行文本装饰器 - 渲染为多行文本输入框
 * @returns 属性装饰器函数
 */
function TextArea() {
    return Property({ multiline: true });
}
/**
 * 只读装饰器 - 禁用编辑功能
 * @returns 属性装饰器函数
 */
function ReadOnly() {
    return Property({ readonly: true });
}
/**
 * 标题装饰器 - 添加分组标题
 * @param title 标题文本
 * @returns 属性装饰器函数
 */
function Header(title) {
    return Property({ label: `__header_${title}` });
}
/**
 * 提示装饰器 - 添加悬停提示信息
 * @param text 提示文本
 * @returns 属性装饰器函数
 */
function Tooltip(text) {
    return Property({ tooltip: text });
}
/**
 * 空间装饰器 - 添加垂直间距
 * @param size 间距大小，默认为10像素
 * @returns 属性装饰器函数
 */
function Space(size = 10) {
    return Property({ label: `__space_${size}` });
}
/**
 * 按钮装饰器 - 将方法渲染为可点击按钮
 * @param label 按钮显示文本，默认使用方法名
 * @returns 方法装饰器函数
 */
function Button(label) {
    return function (target, propertyKey, descriptor) {
        const existingButtons = Reflect.getMetadata(NEXUS_BUTTON_METADATA, target.constructor) || {};
        existingButtons[propertyKey] = {
            label: label || propertyKey,
            method: descriptor.value
        };
        Reflect.defineMetadata(NEXUS_BUTTON_METADATA, existingButtons, target.constructor);
    };
}
/**
 * 获取类的属性元数据
 * @param target 目标类构造函数
 * @returns 属性元数据映射
 */
function getPropertyMetadata(target) {
    return Reflect.getMetadata(Types_1.NEXUS_PROPERTY_METADATA, target) || {};
}
/**
 * 获取类的按钮元数据
 * @param target 目标类构造函数
 * @returns 按钮元数据映射
 */
function getButtonMetadata(target) {
    return Reflect.getMetadata(NEXUS_BUTTON_METADATA, target) || {};
}
/**
 * 菜单装饰器 - 将方法注册为编辑器菜单项
 * @param path 菜单路径，如 "扩展/我的工具"
 * @param label 菜单显示文本
 * @returns 方法装饰器函数
 */
function Menu(path, label) {
    return function (target, propertyKey, descriptor) {
        const existingMenus = Reflect.getMetadata(NEXUS_MENU_METADATA, target.constructor) || [];
        existingMenus.push({
            path: path,
            label: label || propertyKey,
            action: propertyKey,
            method: descriptor.value
        });
        Reflect.defineMetadata(NEXUS_MENU_METADATA, existingMenus, target.constructor);
    };
}
/**
 * 获取类的菜单元数据
 * @param target 目标类构造函数
 * @returns 菜单元数据数组
 */
function getMenuMetadata(target) {
    return Reflect.getMetadata(NEXUS_MENU_METADATA, target) || [];
}
